import {
	getController,
	apiService as Service,
	type HpRequestOptional,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'notifications'

type Mode = 'unread' | 'read'

export const notificationService = {
	...getController<Api.Notification>(url),
	indexByMode: (mode: Mode = 'unread', pageNum = 1) =>
		Service.get({
			url:
				url +
				(mode === 'unread' ? '/unread' : mode === 'read' ? '/read' : '') +
				'?pageNum=' +
				pageNum +
				'&pageSize=5',
		}),
	indexCount: (unread = true) =>
		Service.get({
			url: url + (unread ? '/unread' : '/read') + '_count',
		}),
	damageReport: (data: HpRequestPostPut<Api.DamageReportPostInput>) =>
		Service.post({ url: `${url}/damagereport`, ...data }),
	lostPassword: (data: HpRequestPostPut<{ email: string }>) =>
		Service.post({ url: `${url}/lostpassword`, ...data }),
	message: (data: HpRequestPostPut<{ email: string }>) =>
		Service.post({ url: `${url}/message`, ...data }),
	note: (data: HpRequestPostPut<Api.NotificationPostInput>) => {
		return Service.post({
			url: `${url}/note`,
			data: {
				note_id: data.data.note_id,
				person_ids: data.data.person_ids,
				all_users: data.data.allUsers ? 1 : 0,
			},
		})
	},

	mark: (id: string, read = true) =>
		Service.post({
			url: `${url}/${id}/${read ? 'mark_read' : 'mark_unread'}`,
		}),
	markAllRead: () => Service.post({ url: `${url}/mark_all_read` }),
	preview: ({ name, params }: Record<string, string>) =>
		Service.get({
			url: `${url}/preview/${name}${params}`,
		}),
	welcome: (id: number) =>
		Service.post({
			url: `${url}/welcome`,
			data: {
				user_id: id,
			},
		}),
	welcomeAll: (data: HpRequestOptional) =>
		Service.post({
			url: `${url}/welcome_to_all`,
			...data,
		}),
	sendInvitation: (data: HpRequestOptional) =>
		Service.post({
			url: `${url}/handoverinvitation`,
			...data,
		}),
}

export default notificationService
